import { OperationLogResponseDto } from "@/data/dto/super-admin/operation-log-reponse-dto";
import {
  OperationLogInfoEntity,
  OperationLogUserEntity,
} from "@/domain/entity/super-admin/operation-log-info-entity";
import { getRoleFromString, UserRole } from "@/utils/enum/user-role";
import { assertOperationLogResponseDto } from "@/utils/validation/generated/operation-log-response-dto.validator";

export class OperationInfoMapper {
  static toEntity(dto: OperationLogResponseDto): OperationLogInfoEntity {
    console.log("[OperationInfoMapper] :: toEntity :: 입력 데이터:", JSON.stringify(dto, null, 2));
    assertOperationLogResponseDto(dto);

    const list = dto.list.map((item) => {
      let targetUser: OperationLogUserEntity | undefined = undefined;
      let performer: OperationLogUserEntity | undefined = undefined;

      if (item.subUser) {
        const role = getRoleFromString(item.subUser.role);
        performer = {
          originalId: item.subUser.id,
          displayId: getRoleFromUser(item.subUser.id, role),
          role: role,
        };
      }

      if (item.targetUser) {
        const role = getRoleFromString(item.targetUser.role);
        targetUser = {
          originalId: item.targetUser.id,
          displayId: getRoleFromUser(item.targetUser.id, role),
          role: role,
        };
      }

      const activityDetails = item.detail ? JSON.stringify(item.detail) : "";

      return {
        occurredAt: item.createdAt,
        type: item.type,
        event: item.event,
        performer: performer,
        targetUser: targetUser,
        activityDetails: activityDetails,
      };
    });

    return {
      totalCount: dto.totalCount,
      totalPage: dto.totalPage,
      list: list,
    };
  }
}

function getRoleFromUser(id: string, role: UserRole) {
  switch (role) {
    case "Patient":
      return id;
    case "Doctor":
      return id;
    case "Guardian":
    case "Admin":
    case "SuperAdmin":
      return id.substring(0, 4) + "...";
    default:
      return id;
  }
}
